// extracted by mini-css-extract-plugin
export var chevronIcon = "_8p-2";
export var teamName = "_8p-1";
export var teamSwitcherButton = "_8p-0";